import { Page } from "@/models/page-models/Page";

export const CreateOperator: Page = {
  "path": "create-operator",
  "name": "Operator",
  "props": {
    "data": {
      "title": "Create Operator Account",
      "printable": "FALSE",
      "url": "create-operator",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.username",
                  "label": "Username",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.displayName",
                  "label": "Display Name",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.password",
                  "label": "Password",
                  "disabled": "FALSE",
                  "textType": "password"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.confirmPassword",
                  "label": "Confirm Password",
                  "disabled": "FALSE",
                  "textType": "password"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Account",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "createOperator"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "functions": [
      {
        "name": "createOperator",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/operator/register",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      }
    ]
  },
  "forRole": "PRODUCTION_MANAGER",
  "visible": true
}